import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import type { XCSS } from '@atlaskit/primitives';

// eslint-disable-next-line no-shadow
export enum ElementWidth {
    FULL_WIDTH = 'full-width',
    COMPACT = 'compact',
}

interface TopicsRootProps {
    isCustomizing: boolean;
    elementWidth?: ElementWidth; // default is full-width
    removePadding?: boolean;
    customStyles?: XCSS[];
}

export const ElementRoot: React.FC<React.PropsWithChildren<TopicsRootProps>> = ({
    children,
    isCustomizing,
    elementWidth,
    removePadding,
    customStyles,
}) => {
    const rootXCSS = React.useMemo(() => {
        const xcssStyle = [rootStyle];
        if (elementWidth === ElementWidth.COMPACT) {
            if (isCustomizing) {
                xcssStyle.push(rootStyleWithSidebarOpened);
            } else {
                xcssStyle.push(rootStyleWithSidebarClosed);
            }
        }
        if (!removePadding) {
            xcssStyle.push(rootPaddingStyle);
        }
        if (customStyles) {
            return [...xcssStyle, ...customStyles];
        }
        return xcssStyle;
    }, [isCustomizing, removePadding, elementWidth, customStyles]);
    return <Box xcss={rootXCSS}>{children}</Box>;
};

const rootStyle = xcss({
    alignSelf: 'center',
    width: '100%',
    alignItems: 'center',
});

const rootPaddingStyle = xcss({
    paddingTop: 'space.300',
    paddingBottom: 'space.300',
});

const rootStyleWithSidebarOpened = xcss({
    maxWidth: '336px', // 42 * 8
    // @ts-ignore // because use using custom breakpoints
    '@media (min-width: 80rem)': {
        // ((110 + SIDEBAR_WIDTH_LARGE_MULTIPLIER) * 8) / 16;
        maxWidth: '720px', // 90 * 8
    },
    '@media (min-width: 102rem)': {
        // ((155 + SIDEBAR_WIDTH_LARGE_MULTIPLIER) * 8) / 16;
        maxWidth: '1160px', // 145 * 8
    },
});

const rootStyleWithSidebarClosed = xcss({
    maxWidth: '336px', // 42 * 8
    // @ts-ignore // because use using custom breakpoints
    '@media (min-width: 60rem)': {
        maxWidth: '720px', // 90 * 8
    },
    '@media (min-width: 80rem)': {
        maxWidth: '1160px', // 145 * 8
    },
});
